/**
 * Common component to render a placeholder note and user information.
 *
 * This component needs to be used with a vuex store.
 * That vuex store needs to have a `getUserData` getter that contains
 * {
 *   path: String,
 *   avatar_url: String,
 *   name: String,
 *   username: String,
 * }
 *
 * @example
 * <placeholder-note
 *   :note="{body: 'This is a note'}"
 *   />
 */ import { GlAvatarLink, GlAvatar } from '@gitlab/ui';
import { mapState } from 'pinia';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { renderMarkdown } from '~/notes/utils';
import TimelineEntryItem from '~/vue_shared/components/notes/timeline_entry_item.vue';
import { useNotes } from '~/notes/store/legacy_notes';
export default {
    name: 'PlaceholderNote',
    directives: {
        SafeHtml
    },
    components: {
        GlAvatarLink,
        GlAvatar,
        TimelineEntryItem
    },
    props: {
        note: {
            type: Object,
            required: true
        },
        internalNote: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        ...mapState(useNotes, [
            'getUserData'
        ]),
        renderedNote () {
            return renderMarkdown(this.note.body);
        },
        internalNoteClass () {
            return {
                'internal-note': this.internalNote
            };
        }
    }
};
